import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Card } from "@/components/ui/card";
import { UnderlagSections } from "@/components/UnderlagSections";
import { Loader2, ShieldCheck, AlertCircle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function UnderlagDelad() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    axios.get(`${API}/underlag/shared/${token}`)
      .then((r) => setData(r.data))
      .catch((e) => setError(e.response?.data?.detail || "Länken kunde inte laddas."));
  }, [token]);

  if (error) {
    return (
      <div className="hamn-bg min-h-screen flex items-center justify-center p-4">
        <Card className="rounded-2xl border-border p-8 max-w-md text-center" data-testid="underlag-delad-error">
          <AlertCircle className="h-10 w-10 text-accent mx-auto mb-3" />
          <h1 className="font-head font-semibold text-lg">Länken går inte att öppna</h1>
          <p className="text-sm text-muted-foreground mt-2">{error}</p>
        </Card>
      </div>
    );
  }

  if (data === null) {
    return <div className="hamn-bg min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-primary h-8 w-8" /></div>;
  }

  return (
    <div className="hamn-bg min-h-screen">
      <header className="sticky top-0 z-30 border-b border-border bg-white/90 backdrop-blur-xl">
        <div className="mx-auto max-w-3xl px-4 py-4 flex items-center gap-2.5">
          <img src="/hamn-logo.png" alt="HAMN CV Studio" className="h-9 w-9 rounded-lg object-cover" />
          <div className="font-head font-bold text-primary">HAMN CV Studio</div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-4 py-8 md:py-12" data-testid="underlag-delad-page">
        <h1 className="font-head font-bold text-2xl sm:text-3xl text-primary">Underlag – {data.candidate_name}</h1>
        <p className="text-sm text-muted-foreground mt-1 mb-5">
          Delad granskningsvy av kandidatens råmaterial (profil, karaktär, intervju och referenssvar).
        </p>
        <div className="flex items-center gap-2 text-xs text-muted-foreground mb-6">
          <ShieldCheck className="h-4 w-4 text-primary" /> Detta är en läskopia som delats med dig. Innehållet bygger enbart på det kandidaten själv fyllt i.
        </div>
        <UnderlagSections sections={data.sections} />
      </main>
    </div>
  );
}
